export const CONFIG = {
  MIKADO_REGULAR_CDN: 'https://cdn.novakidschool.com/landing/static/fonts/mikado/Mikado-Web-Regular.woff2',
  MIKADO_BOLD_CDN: 'https://cdn.novakidschool.com/landing/static/fonts/mikado/Mikado-Web-Bold.woff2',
  IS_ENABLED_CLASSROOM_PAGE_RELOAD: process.env.REACT_APP_ENABLED_CLASSROOM_PAGE_RELOAD === 'true',
  DEFAULT_LANDING_URL: process.env.REACT_APP_DEFAULT_LANDING_URL || '',
  STAND_NAME: process.env.REACT_APP_STAND_NAME || 'PROD',
  LOGS_API_URL: process.env.REACT_APP_LOGS_API_URL || '',
  STAND_URL: process.env.REACT_APP_STAND_URL || '',
  IS_DEV: process.env.NODE_ENV === 'development',
  API_URL: process.env.REACT_APP_API_URL || '',
  GROUP_CLASSROOM_API_URL: process.env.REACT_APP_GROUP_CLASSROOM_API_URL || '',
  GTM_ID: process.env.REACT_APP_GTM_ID || '',

  SENTRY_ENVIRONMENT: process.env.REACT_APP_CI_ENVIRONMENT || 'local',
  SENTRY_RELEASE: process.env.REACT_APP_CI_RELEASE || '<undefined>',
  BLR_TEACHER_KEY: process.env.REACT_APP_BLR_TEACHER_KEY || '',
  BLR_PARENT_KEY: process.env.REACT_APP_BLR_PARENT_KEY || '',
  SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN || '',
};

if (CONFIG.STAND_NAME !== 'PROD') {
  console.log('process.env=', process.env);
  console.log('config', CONFIG);
}
